<template>
<div>
    <v-row justify="center">
        <v-col cols="12" xs="12" sm="12" md="10">
            <h3>
                <v-icon>mdi-calendar</v-icon>Localization
            </h3>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="3">Date and Time Formats</v-col>
        <v-col cols="12" xs="12" sm="12" md="7">

            <v-select id="dateFormat" label="Display Date Format" :items="dateFormatOptions" item-text="text" item-value="value" v-model="globalDateFormat" />
            <v-select label="Display Time Format" :items="timeFormatOptions" item-text="text" item-value="value" v-model="globalTimeFormat" />

        </v-col>

        <v-col cols="12" xs="12" sm="12" md="10" v-if="anyInterfaceConfigEnabled">
            <h3>
                <v-icon>mdi-view-quilt</v-icon>Interface
            </h3>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="3" v-if="anyInterfaceConfigEnabled">
            <v-icon>mdi-pallette</v-icon>Themes / Colors
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="7">

            <div v-if="userSpecifyThemesEnabled">

                <v-select :items="themes" item-text="name" item-value="id" v-model="currentTheme" />
                <v-switch color="primary" label="Dark Mode" v-model="globalDarkMode" disabled/>

            </div>

            <div v-if="userSpecifyColorsEnabled">
                <color-picker show-swatches hide-canvas v-model="globalTopBarColor" label="Top Bar Background Color" />
                <color-picker show-swatches hide-canvas v-model="globalNavBackgroundColor" label="Nav Background Color" />
                <color-picker show-swatches hide-canvas v-model="globalContentBackgroundColor" label="Content Background Color" />
                <color-picker show-swatches hide-canvas v-model="globalAppBackgroundColor" label="Window Background Color" />
            </div>
            <br />
            <div v-if="userSpecifyBackgroundEnabled">
                <label>Background</label>
                <v-row>
                    <v-col sm="4" v-for="(item, i) in images" :key="i">
                        <v-card :color="item.name === globalBackgroundImage ? 'primary' : null" class="bg-card" :class="{selected : item.name === globalBackgroundImage}">
                            <!-- {opacity: item.name === backgroundImage ? 1 : 0.2,cursor: 'pointer'} -->
                            <v-img @click="globalBackgroundImage = item.name" :src="item.url" height="150">
                                <v-chip small :large="item.name === globalBackgroundImage" dark label :color="item.name === globalBackgroundImage ? 'primary' : null">{{item.name}}</v-chip>
                            </v-img>
                            <v-toolbar dense flat color="transparent">
                                <v-spacer/>
                                <v-btn depressed color="primary" @click="globalBackgroundImage = item.name">Select</v-btn> 
                            </v-toolbar>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
            <br />
            <v-card>
                <copyable>
<!-- <pre>
        {
            id : "... id your theme ...",
            name : "... name your theme ...",
            dark : {{globalDarkMode}},
            navBackgroundColor: {{JSON.stringify(globalNavBackgroundColor)}},  
            contentBackgroundColor: {{JSON.stringify(globalContentBackgroundColor)}},
            appBackgroundColor: {{JSON.stringify(globalAppBackgroundColor)}},
            topBarColor : {{JSON.stringify(globalTopBarColor)}},
            backgroundImage:'{{globalBackgroundImage}}'
        }
</pre> -->
                </copyable>
            </v-card>
        </v-col>
    </v-row>
</div>
</template>

<script>
import moment from "moment";
import colorPicker from "@/_components/inputs/color-picker";
import userSettings from "@/_mixins/user-settings-mixin";
import theme from "@/_config/theme";
import uiView from "@/_mixins/ui-view-mixin";
import globalAppConfig from "@/app.config.global.js"
import copyable from "@/_components/shared/copyable"
export default {
    name: "MySettings",
    components: {
        colorPicker,copyable
    },
    mixins: [userSettings, uiView, userSettings],
    //el:'#element',
    data() {
        return {
            // selectedTheme: "",
            // customThemeName: "Untitled Theme",
        };
    },
    async created() {
        try {
            // var user = await this.getCurrentUser()
        } catch (err) {
            this.globalErrors.push(err);
        } finally {}
    },
    watch: {
    },
    computed: {
        anyInterfaceConfigEnabled() {
            return this.userSpecifyColorsEnabled || this.userSpecifyBackgroundEnabled || this.userSpecifyThemesEnabled
        },
        userSpecifyColorsEnabled() {
            return globalAppConfig.userSpecifyColorsEnabled;
        },
        userSpecifyBackgroundEnabled() {
            return globalAppConfig.userSpecifyBackgroundEnabled;
        },
        userSpecifyThemesEnabled() {
            return globalAppConfig.userSpecifyThemesEnabled;
        },
        images() {
            return theme.backgroundImages;
        },
        appStyles() {
            var img = this.selected.url;
            var img1 = "'" + img + "'";
            //console.log(img1);
            // var image = require('_static/img/background/bag1.jpg')
            return {
                //backgroundImage : `url(${img1})`
                backgroundImage: `url('${img1}')`,
            };
        },
        dateFormatOptions() {
            var now = moment();
            var formats = [
                "DD-MM-YYYY",
                "DD MMMM YYYY",
                "YYYY-MM-DD",
                "MMM DD, YYYY",
                "ddd - MMM DD, YYYY",
            ];

            return formats.map((e) => {
                return {
                    text: now.format(e),
                    value: e,
                };
            });
        },
        timeFormatOptions() {
            var now = moment();
            var formats = [{
                    format: "h:mm a",
                    name: "12 Hour AM/PM"
                },
                {
                    format: "HH:mm",
                    name: "24 Hour Clock"
                },
            ];

            return formats.map((e) => {
                return {
                    text: `${e.name} [${now.format(e.format)}]`,
                    value: e.format,
                };
            });
        },
    },
    methods: {
        remove(item) {
           // debugger;
            // var themes = this.globalCustomThemes;
            // this.globalCustomThemes
        },
        handleTopBarColorChange(value) {
            this.globalTopBarColor = value.value;
        },
    },
};
</script>

<style lang="scss" scoped>

.bg-card
{

}
</style>
